<template>
  <div class="mision">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section
      class="pantalla mision1_1"
      v-bind:class="{
        bg1: reto == 0,
        bg2: reto == 1,
        bg3: reto == 2,
        bg4: reto == 3,
        bg5: reto == 4,
        bg6: reto == 5,
        bg7: reto == 6,
        bg8: reto == 7,
        bg9: reto == 8,
        bg10: reto == 9,
        bg11: reto == 10,
        bg12: reto == 11,
        bg13: reto == 12,
        bg14: reto == 13,
        bg15: reto == 14,
        bg16: reto == 15,
        bg17: reto == 16,
        bg18: reto == 17,
        bg19: reto == 18,
        bg20: reto == 19,
        bg21: reto == 20,
        bg22: reto == 21,
        bg23: reto == 22,
        bg24: reto == 23,
        bg25: reto == 24,
        bg26: reto == 25,
        bg27: reto == 26,
        bg28: reto == 27,
        bg29: reto == 28,
        bg30: reto == 29,
        bg31: reto == 30,
      }"
      v-if="!resultado && reto != -1"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/bg-pregunta-trapezoide.png"
                alt="Encauce"
                class="img-fluid w-100"
              />
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="blanco bold" v-html="retos[reto].texto"></div>
                <div class="electrico" v-html="retos[reto].instruccion"></div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              @click="avanzar"
              class="btnavanzar abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-siguiente.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Presiona la flecha </span>
                <span class="bold">para continuar</span>
              </div>
            </div>

            <div
              @click="retroceder"
              class="btnretroceder abs"
              data-aos="fade-left"
              data-aos-delay="200"
              v-if="this.reto > 0"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-atras.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Regresar al </span>
                <span class="bold">reto anterior</span>
              </div>
            </div>

            <div
              @click="toggleOraculo"
              class="oraculo abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/oraculo.png"
                alt="Encauce"
                class="img-fluid w100 btnoraculo"
              />
              <div
                class="dialogo"
                :class="{ active: oraculo === true && tip_oraculo != null }"
              >
                <img
                  src="../../../assets/imgs/mision/dialogo-oraculo.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="cerrar blanco bold">x</div>
                <div class="titulo cyan bold uppercase">
                  {{ tip_oraculo.tipo }}
                </div>
                <div class="texto blanco text-center">
                  {{ tip_oraculo.texto }}
                </div>
              </div>
            </div>

            <!---->

            <div class="menu" v-if="tipo_reto == 'orden'">
              <img
                src="../../../assets/imgs/mision/medidor-afinidad.png"
                alt="Encauce"
                class="img-fluid medidor"
              />

              <div class="contenedoropciones">
                <sortable
                  class="opcionessortable"
                  v-for="(item, index) in retos[reto].respuestas"
                  v-model="dragData"
                  v-bind:key="item.id"
                  :index="index"
                  drag-direction="horizontal"
                  replace-direction="horizontal"
                  @sortend="sortend($event, retos[reto].respuestas, reto)"
                  @real-click="click"
                >
                  <div class="opcion">
                    <img
                      src="../../../assets/imgs/mision/bg-pregunta-grande.png"
                      alt="pregunta"
                    />
                    <div class="texto" v-html="item.texto"></div>
                  </div>
                </sortable>
              </div>
            </div>

            <div class="menu multiple" v-if="tipo_reto == 'multiple'">
              <img
                src="../../../assets/imgs/mision/bg-checks.png"
                alt="Encauce"
                class="img-fluid medidor"
              />

              <div class="contenedoropciones">
                <div
                  class="opcionesmultiple"
                  v-for="(item, index) in retos[reto].respuestas"
                  v-bind:key="item.id"
                  :index="index"
                >
                  <div class="opcion">
                    <img
                      src="../../../assets/imgs/mision/bg-pregunta-grande.png"
                      alt="pregunta"
                    />
                    <div class="texto" v-html="item.texto"></div>

                    <div
                      @click="clickCheckbox(index)"
                      :class="'checkbox checkbox' + index + ' abs'"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <img
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                      <div class="check" :class="{ active: res == index }">
                        <img
                          src="../../../assets/imgs/mision/check.png"
                          alt="Encauce"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="menu seleccion"
              v-if="tipo_reto == 'seleccion'"
              :class="{ dragging: dragging === true }"
            >
              <div class="contmedidor">
                <div class="medidor">
                  <img
                    src="../../../assets/imgs/mision/bg-check-tache.png"
                    alt="Encauce"
                    class="img-fluid noevents w-100"
                  />

                  <div
                    @click="dragEnterSelect('check')"
                    @mousedown="dragEnterSelect('check')"
                    class="drag check"
                    transfer-data="check"
                  >
                    <img
                      src="../../../assets/imgs/mision/check.png"
                      alt="Encauce"
                      class="img-fluid medidor"
                      :class="{ glowing: tipo_seleccionado == 'check' }"
                    />
                  </div>

                  <div
                    @click="dragEnterSelect('tache')"
                    @mousedown="dragEnterSelect('tache')"
                    class="drag tache"
                    transfer-data="tache"
                  >
                    <img
                      src="../../../assets/imgs/mision/tache.png"
                      alt="Encauce"
                      class="img-fluid medidor"
                      :class="{ glowing: tipo_seleccionado == 'tache' }"
                    />
                  </div>
                </div>
              </div>

              <div class="contenedoropciones">
                <div
                  class="opcionesseleccion"
                  v-for="(item, index) in retos[reto].respuestas"
                  v-bind:key="item.id"
                  :index="index"
                >
                  <div class="opcion">
                    <div
                      class="drop"
                      @click="handleDrop(index)"
                      @mouseup="handleDrop(index)"
                      :class="'checkbox checkbox' + index + ' abs'"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <img
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                      <div
                        class="check"
                        :class="{ active: seleccionado_check == index }"
                      >
                        <img
                          src="../../../assets/imgs/mision/check.png"
                          alt="Encauce"
                          class="img-fluid"
                        />
                      </div>
                      <div
                        class="tache"
                        :class="{ active: seleccionado_tache == index }"
                      >
                        <img
                          src="../../../assets/imgs/mision/tache.png"
                          alt="Encauce"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-else>
      <div class="mision resultado">
        <div class="row">
          <div
            class="col-12 contentabs d-flex flex-column justify-content-center"
          >
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>
            <div class="tiempo abs text-center mtn7">
              <div class="cyan pt7 ls3" data-aos="fade-up" data-aos-delay="0">
                TIEMPO DE RESPUESTA:
              </div>

              <div
                class="cyan pt2 numero"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <img
                  class="medidor"
                  src="../../../assets/imgs/mision/medidor.png"
                  alt="respuesta"
                />
                <div class="ls3 electrico valor bold">{{ time }}</div>
                <div class="electrico bold ls6 unidad">SEGUNDOS</div>
              </div>

              <div
                class="cyan ls3 corchetes"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <span>
                  <img
                    class="izq"
                    src="../../../assets/imgs/mision/corchete-izq.png"
                    alt="respuesta"
                  />
                  <span class="bold">¡ooh! eres rápido</span>
                  <img
                    class="der"
                    src="../../../assets/imgs/mision/corchete-der.png"
                    alt="respuesta"
                  />
                </span>
              </div>

              <div class="py3"></div>

              <div
                class="cyan ls3 quasar-respuesta"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <img
                  src="../../../assets/imgs/mision/quasar-respuesta.png"
                  alt="respuesta"
                />
                <div class="texto">
                  <div class="text-left">
                    <span class="bold">¡Bien explorador!</span> Ahora veamos qué
                    harás cuando tienes que
                    <span class="bold">aprender algo nuevo.</span>
                    <img
                      src="../../../assets/imgs/mision/vineta-final.png"
                      alt="respuesta"
                    />
                  </div>
                </div>
              </div>

              <div
                class="col-12 footer"
                data-aos="fade-left"
                data-aos-delay="600"
              >
                <div class="row">
                  <div
                    class="col-4 offset-4 cyan d-flex justify-content-center flex-column"
                  >
                    <div>Misión 01- Planeta Aprentix 12</div>
                    <div class="bold">
                      <span class="diagonales">///</span> Reto 01 de 04
                      Completado
                    </div>
                  </div>
                  <div class="col-4 cont-btn-sig">
                    <button @click="siguienteMision" class="btn-sig">
                      <span class="texto">
                        <span class="bold">SIGUIENTE MISIÓN</span>
                      </span>
                      <img
                        class="icono"
                        src="../../../assets/imgs/mision/cohete.png"
                        alt="icono"
                      />
                      <span class="flecha">
                        <img
                          src="../../../assets/imgs/mision/flecha-sig3.png"
                          alt="icono"
                        />
                      </span>
                    </button>
                    <div class="flecha2">
                      <img
                        src="../../../assets/imgs/mision/flecha-sig2.png"
                        alt="icono"
                      />
                    </div>
                    <div class="flecha1">
                      <img
                        src="../../../assets/imgs/mision/flecha-sig1.png"
                        alt="icono"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="hidden abs">
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-1.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-2.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-3.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-4.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-5.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-6.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-7.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-8.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-9.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-10.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-11.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-12.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-13.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-14.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-15.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-16.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-17.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-18.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-19.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-20.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-21.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-22.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-23.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-24.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-25.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-26.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-27.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-28.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-29.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-30.jpg"
        alt="precarga"
      />
      <img
        src="../../../assets/imgs/mision/2/bg-mision-2-31.jpg"
        alt="precarga"
      />
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";
import swal from "sweetalert2";
import router from "../../../router/index";

import Sortable from "vue-drag-sortable";

const PUNTAJE_MINIMO_COMPETENCIA = 70;
const FORTALEZA_EXTRA_PUNTOS = 5;

export default {
  components: {
    Footer,
    Sortable,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      tip_oraculo: null,
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      res: -1,
      oraculo: false,
      resultado: false,
      time: 0,
      mision: 2,
      reto: -1,
      dragData: {},
      lista_ordenada: null,
      habilidad: [
        "procedimental",
        "empatico",
        "analitico",
        "creativo",
        "perfeccionista",
      ],
      retos: [
        {
          id: 1,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Antes de empezar tu aventura, tienes tiempo libre y puedes visitar a un grupo de amigos(as). ¿A qué grupo eliges?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Experimentadas y productivas.",
              habilidad: 0,
            },
            {
              texto: "Sentimentales y afectuosas.",
              habilidad: 1,
            },
            {
              texto: "Lógicas y analíticas.",
              habilidad: 2,
            },
            {
              texto: "Soñadoras y creativas.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 2,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Entraste a la zona telepática. Las personas te perciben cómo:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Una persona arriesgada y con ideas.",
              habilidad: 3,
            },
            {
              texto: "Una persona productiva, confiable y disciplinada.",
              habilidad: 0,
            },
            {
              texto:
                "Una persona que le gusta comunicarse con las demás, hablar con ellos y escucharlos.",
              habilidad: 1,
            },
            {
              texto:
                "Una persona decidida, analítica y orientada a resultados.",
              habilidad: 2,
            },
          ],
        },
        {
          id: 3,
          tipo: "orden",
          categoria: "TL",
          texto:
            "En tu plan de vuelo hay tiempo para ir a divertirse en el Sector Entre Ten, ¿qué prefieres para tu visita?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Informarme con tiempo en folletos para planear con anticipación mis actividades.",
              habilidad: 0,
            },
            {
              texto:
                "Identificar cuáles son las atracciones más relevantes y sus antecedentes.",
              habilidad: 2,
            },
            {
              texto: "Ir acompañado de alguien conocido.",
              habilidad: 1,
            },
            {
              texto: "Recorrer rápidamente todo el lugar.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 4,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Hay que planear las próximas vacaciones, ¿qué te gustaría hacer?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Ir a un sitio en donde pueda practicar un deporte.",
              habilidad: 2,
            },
            {
              texto: "Visitar y reunirme con mis familiares y amigos.",
              habilidad: 1,
            },
            {
              texto: "Los viajes en donde haya aventura y deportes extremos.",
              habilidad: 3,
            },
            {
              texto: "Planear el viaje con anticipación a un lugar conocido.",
              habilidad: 0,
            },
          ],
        },
        {
          id: 5,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Aterrizamos en una biblioteca galáctica y necesitas leer un libro para seguir tu camino. ¿Cuál te interesa más?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Relatos de aventura o ficción, cuanto más extraordinarias son las historias más me gustan, me hacen soñar.",
              habilidad: 3,
            },
            {
              texto:
                "Libros recomendados y sugeridos por amigos. Leo muchas novelas, me gustan las historias románticas.",
              habilidad: 1,
            },
            {
              texto:
                "No dejar pasar nada, presto mucha atención. No me gusta dejar un libro cuando lo he empezado.",
              habilidad: 0,
            },
            {
              texto:
                "Libros que me permitan aprender un método o técnica y aplicar un conocimiento en donde tenga que utilizar herramientas de precisión y de control.",
              habilidad: 2,
            },
          ],
        },
        {
          id: 6,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Hoy es el día universal del descanso y tienes todo el día libre, ¿qué te gustaría hacer?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Hacer actividades espontáneas, no planeadas con otras personas.",
              habilidad: 1,
            },
            {
              texto: "Hacer reparaciones o trabajos en casa.",
              habilidad: 2,
            },
            {
              texto: "Realizar actividades planeadas.",
              habilidad: 0,
            },
            {
              texto: "Pensar/soñar sobre el futuro.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 7,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Te ganaste tus primeras criptomonedas y las puedes invertir para hacer más dinero, ¿en qué lo harías?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Proyectos que generan grandes ganancias aunque haya cierto riesgo.",
              habilidad: 3,
            },
            {
              texto: "Ahorrarlo en el banco donde está seguro.",
              habilidad: 0,
            },
            {
              texto: "En una tanda o fondo de ahorro con amigos y familiares.",
              habilidad: 1,
            },
            {
              texto: "En comprar un terreno.",
              habilidad: 2,
            },
          ],
        },
        {
          id: 8,
          tipo: "multiple",
          categoria: "NF",
          texto: "Llegó el fin de semana, ¿cómo piensas pasar tu tiempo libre?",
          instruccion:
            "Selecciona solo una opción haciendo click en el círculo.",
          respuestas: [
            {
              texto: "Haciendo lo que quiero, me gusta y disfruto.",
              habilidad: 3,
            },
            {
              texto: "Haciendo cosas que mi familia y amigos quieren hacer.",
              habilidad: 1,
            },
            {
              texto: "Haciendo lo que es importante.",
              habilidad: 2,
            },
            {
              texto: "Haciendo lo que he planeado.",
              habilidad: 0,
            },
          ],
        },
        {
          id: 9,
          tipo: "orden",
          categoria: "TL",
          texto:
            "Acabas de conocer habitantes de un nuevo planeta. Cuando hablas con ellos sueles ser:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Enfocado en hechos y datos, conciso, concreto y directo.",
              habilidad: 2,
            },
            {
              texto:
                "Un buen conversador, puedo extenderme, expreso emociones y sentimientos.",
              habilidad: 1,
            },
            {
              texto:
                "Normalmente tengo buen sentido del humor, me destaco por tener buenas e innovadoras ideas.",
              habilidad: 3,
            },
            {
              texto:
                "Narro lo sucedido, sin dar mayores detalles, sólo lo relevante e importante.",
              habilidad: 0,
            },
          ],
        },
        {
          id: 10,
          tipo: "orden",
          categoria: "TL",
          texto:
            'Tus amigos y amigas galácticos quieren saber más sobre los "Deportes en equipo", tu opinas que: ',
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Doy importancia a los deportes en equipo, pero no soy fanático de ninguno.",
              habilidad: 2,
            },
            {
              texto:
                "Considero que los deportes en equipo son ejemplo de conseguir buenos resultados basados en la técnica y organización. ",
              habilidad: 0,
            },
            {
              texto:
                "Valoro los deportes en equipo por que se puedo compartir mis emociones e interactuar con otros.",
              habilidad: 1,
            },
            {
              texto:
                "Creo que los deportes en equipo mejoran la comunicación e impulsan el trabajo colaborativo. ",
              habilidad: 3,
            },
          ],
        },
        {
          id: 11,
          tipo: "orden",
          categoria: "AP",
          texto:
            "¡Hola explorador(a)! Haremos una prueba. Conéctate al sensor de ondas cerebrales y dinos, te consideras una persona:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Confrontador(a)",
              habilidad: 2,
            },
            {
              texto: "Visionario(a)",
              habilidad: 3,
            },
            {
              texto: "Afectivo(a)",
              habilidad: 1,
            },
            {
              texto: "Perfeccionista",
              habilidad: 0,
            },
          ],
        },
        {
          id: 12,
          tipo: "orden",
          categoria: "AP",
          texto: "Te consideras alguien:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Creativo(a)",
              habilidad: 3,
            },
            {
              texto: "Audaz",
              habilidad: 2,
            },
            {
              texto: "Ordenado(a)",
              habilidad: 0,
            },
            {
              texto: "Sentimental",
              habilidad: 1,
            },
          ],
        },
        {
          id: 13,
          tipo: "orden",
          categoria: "AP",
          texto: "Te consideras alguien:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Cauteloso(a)",
              habilidad: 0,
            },
            {
              texto: "Sociable",
              habilidad: 2,
            },
            {
              texto: "Soñador(a)",
              habilidad: 3,
            },
            {
              texto: "Concreto(a)",
              habilidad: 1,
            },
          ],
        },
        {
          id: 14,
          tipo: "orden",
          categoria: "AP",
          texto: "Te consideras alguien:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Innovador(a)",
              habilidad: 3,
            },
            {
              texto: "Tradicional",
              habilidad: 0,
            },
            {
              texto: "Lógico(a)",
              habilidad: 2,
            },
            {
              texto: "Emocional",
              habilidad: 1,
            },
          ],
        },
        {
          id: 15,
          tipo: "orden",
          categoria: "AP",
          texto: "Te consideras alguien:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Racional",
              habilidad: 2,
            },
            {
              texto: "Minucioso(a)",
              habilidad: 0,
            },
            {
              texto: "Imaginativo(a)",
              habilidad: 3,
            },
            {
              texto: "Espiritual",
              habilidad: 1,
            },
          ],
        },
        {
          id: 16,
          tipo: "multiple",
          categoria: "NF",
          texto:
            "Hemos identificado tus principales características como terrícola, pero ahora dime, ¿cuál sería con la que más te identificas?",
          instruccion:
            "Selecciona solo una opción, selecciona un recuadro para marcarlo.",
          respuestas: [
            {
              texto: "Creativo(a)",
              habilidad: 3,
            },
            {
              texto: "Ordenado(a)",
              habilidad: 0,
            },
            {
              texto: "Analítico(a)",
              habilidad: 2,
            },
            {
              texto: "Emocional",
              habilidad: 1,
            },
            // {
            //   texto: "Perfeccionista",
            //   habilidad: 4,
            // },
          ],
        },
        {
          id: 17,
          tipo: "orden",
          categoria: "AP2",
          texto: "Ahora dime, ¿qué frase te define mejor?:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Me gusta conocer nuevos pueblos, conocer mi país.",
              habilidad: 3,
            },
            {
              texto:
                "Me gusta aprender cosas nuevas, para mi es muy importante la capacitación.",
              habilidad: 2,
            },
            {
              texto: "Me gusta planear mi trabajo y todas mis actividades.",
              habilidad: 0,
            },
            {
              texto: "Me gusta ver programas en televisión que me hagan feliz.",
              habilidad: 1,
            },
          ],
        },
        {
          id: 18,
          tipo: "seleccion",
          categoria: "NF",
          texto:
            "Tu escuadrón es Encauce Centauri, ¡Bienvenido(a)! Debes elegir un emblema para que tus compañeros puedan identificarte. ¿Qué símbolo te representa y cuál no?:",
          instruccion:
            " <strong class='fpXG'>Arrastra la equis o la paloma</strong> a las naves de acuerdo a tu personalidad.",
          respuestas: [
            {
              texto: "",
              habilidad: 3,
            },
            {
              texto: "",
              habilidad: 0,
            },
            {
              texto: "",
              habilidad: 1,
            },
            {
              texto: "",
              habilidad: 2,
            },
          ],
        },
        {
          id: 19,
          tipo: "orden",
          categoria: "Joven",
          texto:
            "Es tu primer día en la Academia de Pilotos(as) N-kau 3. Por favor menciona, ¿cómo eres cuando estás en la escuela?:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Preparado, comprometido, detallista.",
              habilidad: 0,
            },
            {
              texto: "Motivador, inspirador, interactivo.",
              habilidad: 1,
            },
            {
              texto:
                "Estoy al tanto de la información de la última tecnología.",
              habilidad: 2,
            },
            {
              texto: "Emprendedor, con energía para nuevos retos.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 20,
          tipo: "orden",
          categoria: "Joven",
          texto: "¿Qué es lo que no te gusta de la escuela?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Enfrentar desorganización.",
              habilidad: 0,
            },
            {
              texto: "La falta de cooperación.",
              habilidad: 1,
            },
            {
              texto:
                "La falta de información, de hechos y datos para tomar decisiones.",
              habilidad: 2,
            },
            {
              texto: "Que me digan lo que tengo que hacer.",
              habilidad: 3,
            },
          ],
        },
        {
          id: 21,
          tipo: "orden",
          categoria: "Joven",
          texto: "Completa la frase. Además de gustarme, soy bueno(a) para:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Los análisis financieros y/o matemáticos.",
              habilidad: 2,
            },
            {
              texto: "Manejar archivos y registro de datos.",
              habilidad: 0,
            },
            {
              texto: "Crear e inventar.",
              habilidad: 3,
            },
            {
              texto: "Orientar a compañeros, cuando tienen problemas.",
              habilidad: 1,
            },
          ],
        },
        {
          id: 22,
          tipo: "orden",
          categoria: "Joven",
          texto: "soy bueno(a) para:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Negociar y busco la manera de ganar",
              habilidad: 2,
            },
            {
              texto:
                "Desarrollar tareas de rutina y las hago con mucha precisión",
              habilidad: 0,
            },
            {
              texto: "Animar o impulsar a otros y seducirlos con mi entusiasmo",
              habilidad: 3,
            },
            {
              texto:
                "Festejar. Normalmente soy el primero en saber cuándo es el momento para una celebración",
              habilidad: 1,
            },
          ],
        },
        {
          id: 23,
          tipo: "orden",
          categoria: "Joven",
          texto: "Además de gustarme, soy bueno(a) para:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Proponer nuevos proyectos",
              habilidad: 3,
            },
            {
              texto: "Ser el responsable de lo que se tiene que hacer",
              habilidad: 2,
            },
            {
              texto: "Planificar mi agenda y mis actividades",
              habilidad: 0,
            },
            {
              texto: "Ser el líder de mis compañeros",
              habilidad: 1,
            },
          ],
        },
        {
          id: 24,
          tipo: "orden",
          categoria: "Joven",
          texto:
            "Imagina qué debes hacer un plan para salvar a tu escuadrón en una misión difícil. ¿Qué o cómo lo harías?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Tengo en cuenta la armonía y la cooperación",
              habilidad: 1,
            },
            {
              texto:
                "Prefiero trabajar en forma simultánea, procesando varias ideas al mismo tiempo",
              habilidad: 3,
            },
            {
              texto:
                "Organizo el material en puntos clave y en principios operativos",
              habilidad: 2,
            },
            {
              texto: "Utilizo un método paso a paso",
              habilidad: 0,
            },
          ],
        },
        {
          id: 25,
          tipo: "orden",
          categoria: "Joven",
          texto:
            "Tu plan será sometido a discusión con el consejo de la Academia. ¿Cómo lo afrontas?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Busco restablecer la armonía",
              habilidad: 1,
            },
            {
              texto: "Trato de involucrarme",
              habilidad: 0,
            },
            {
              texto: "Utilizo mis habilidades para ganar",
              habilidad: 2,
            },
            {
              texto: "Busco llegar a un acuerdo",
              habilidad: 3,
            },
          ],
        },
        {
          id: 26,
          tipo: "orden",
          categoria: "Joven",
          texto: "Tus amigos(as) terrestres de la escuela te ven cómo una persona:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Soñadora y creativa",
              habilidad: 3,
            },
            {
              texto: "Calculadora y racional",
              habilidad: 2,
            },
            {
              texto: "Empática y motivadora",
              habilidad: 1,
            },
            {
              texto: "Conservadora y tradicional",
              habilidad: 0,
            },
          ],
        },
        {
          id: 27,
          tipo: "orden",
          categoria: "Joven",
          texto:
            "En la escuela terrestre, ven como algo negativo en mi, ser una persona:",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Calculadora",
              habilidad: 2,
            },
            {
              texto: "Propenso al contacto físico, hablador",
              habilidad: 1,
            },
            {
              texto: "Poco imaginativa(o), que se opone a las cosas nuevas",
              habilidad: 0,
            },
            {
              texto: "Que no se concentra",
              habilidad: 3,
            },
          ],
        },
        {
          id: 28,
          tipo: "orden",
          categoria: "Joven",
          texto: "Ok, gracias. Ahora, disfrutas participar cuando...",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Tengo la oportunidad de interactuar con otras personas",
              habilidad: 1,
            },
            {
              texto: "Tengo unas metas que debo alcanzar",
              habilidad: 2,
            },
            {
              texto:
                "Tengo unas instrucciones y procedimientos específicos que debo seguir",
              habilidad: 0,
            },
            {
              texto:
                "Tengo que desarrollar actividades que no son rutinarias y debo generar ideas innovadoras",
              habilidad: 3,
            },
          ],
        },
        {
          id: 29,
          tipo: "orden",
          categoria: "Joven",
          texto: "¿Qué haces normalmente cuando te comunicas con los demás?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Intranquilizarme cuando veo que no utilizan la lógica para expresar sus ideas",
              habilidad: 2,
            },
            {
              texto:
                "Perder la concentración cuando veo que las discusiones se alargan",
              habilidad: 0,
            },
            {
              texto: "Perder el interés cuando entran en demasiado detalle",
              habilidad: 3,
            },
            {
              texto: "No poner atención a discusiones de tipo técnico",
              habilidad: 1,
            },
          ],
        },
        {
          id: 30,
          tipo: "orden",
          categoria: "Joven",
          texto: "¿Qué haces cuando quieres influir en las demás personas?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto:
                "Les hago énfasis en los formatos y procedimientos existentes",
              habilidad: 0,
            },
            {
              texto: "Les hablo sobre el marco general del proyecto",
              habilidad: 3,
            },
            {
              texto: "Les doy hechos y datos",
              habilidad: 2,
            },
            {
              texto: "Les hablo del trabajo en equipo y crecimiento personal",
              habilidad: 1,
            },
          ],
        },
        {
          id: 31,
          tipo: "orden",
          categoria: "Joven",
          texto: "Cuando debes tomar una decisión, ¿qué haces?",
          instruccion:
            "Ordena las respuestas de mayor a menor de acuerdo a tu personalidad. <br> Arrastra las respuestas para ordenarlas.",
          respuestas: [
            {
              texto: "Confío en los presentimientos",
              habilidad: 3,
            },
            {
              texto: "Confío en la lógica",
              habilidad: 2,
            },
            {
              texto: "Me baso en los casos de éxito",
              habilidad: 0,
            },
            {
              texto: "Busco soluciones donde todos ganan",
              habilidad: 1,
            },
          ],
        },
      ],
      respuestas_usuario: null,
      avance: null,
      x: null,
      y: null,
      resultado_evaluacion: {
        competencias: null,
        fortaleza: null,
      },
      valores: [4, 3, 2, 1],
      suma: {
        habilidad_0: 0,
        habilidad_1: 0,
        habilidad_2: 0,
        habilidad_3: 0,
      },
      fortaleza: {
        habilidad_0: 0,
        habilidad_1: 0,
        habilidad_2: 0,
        habilidad_3: 0,
      },
      tipo_reto: null,
      tache: "tache",
      check: "check",
      seleccionado_check: null,
      seleccionado_tache: null,
      tipo_seleccionado: null,
      dragging: false,
      initiated: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init() {
      if (this.userProfile == null || this.initiated == true) {
        return;
      }

      console.log("iniciando mision " + this.mision);

      this.initiated = true;

      /////////////////////
      this.reto = this.$route.params.reto - 1;
      console.log({ reto_route: this.reto });

      this.tipo_reto = this.retos[this.reto].tipo;
      this.res = -1;

      this.setRespuestasUsuario();

      AOS.init({
        offset: -120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 800, // values from 0 to 3000, with step 50ms
        easing: "ease-in-out", // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      });

      this.initTimer();
      this.getOraculo();
    },
    getOraculo() {
      let oraculo = this.$store.state.oraculo;
      let rand = Math.floor(Math.random() * (oraculo.length - 1)) + 0;
      this.tip_oraculo = oraculo[rand];
    },
    verificaAutopercepcion() {
      if (this.retos[this.reto].id == "16") {
        let opcionesAP = [];
        this.respuestas_usuario.forEach((reto) => {
          if (reto.categoria == "AP") {
            opcionesAP.push(reto.respuestas[0]);
          }
        });

        this.retos[this.reto].respuestas = opcionesAP;

        console.log({ retosAP: opcionesAP });
      }
    },
    async setRespuestasUsuario() {
      console.log({ settingrespuesta_usaurio: this.reto });
      if (this.reto == 0) {
        this.respuestas_usuario = this.retos;
        await this.getAvance();
      } else {
        await this.getLocalStorage();
        //await this.getAvance();
        this.verificaAutopercepcion();
      }

      console.log({ respuestas_usuario: this.respuestas_usuario });
    },
    async getLocalStorage() {
      this.avance = await this.$store.dispatch("getLocalStorage");
      this.respuestas_usuario = this.avance.misiones[
        this.mision - 1
      ].respuestas;
    },
    async getAvance() {
      console.log({ reto: this.reto - 1 });
      this.avance = await this.$store.dispatch("getAvance");

      try {
        this.respuestas_usuario = this.avance.misiones[
          this.mision - 1
        ].respuestas;
      } catch (e) {
        console.log("respuesas usuario reiniciadas");
        this.respuestas_usuario = this.retos;
        this.$router.push("/mision-2-template/1");
      }

      let inIdsPrueba = await this.$store.dispatch("inIdsPrueba");

      if (this.avance.misiones[1] != null && inIdsPrueba === false) {
        this.$router.push("/mision-2-resultados");
      }
    },
    click(e) {
      // Todo
    },
    clickCheckbox(index) {
      //console.log(index);
      this.res = index;
    },
    sort(e) {
      const { oldIndex, newIndex } = e;
      console.log(oldIndex, newIndex);
    },
    sortend(e, list, reto) {
      console.log(reto);
      console.log(list);
      this.lista_ordenada = list;

      this.respuestas_usuario[reto].respuestas = list;

      console.log({ sortend: this.respuestas_usuario });

      const { oldIndex, newIndex } = e;
      this.rearrange(list, oldIndex, newIndex);
    },
    rearrange(array, oldIndex, newIndex) {
      if (oldIndex > newIndex) {
        array.splice(newIndex, 0, array[oldIndex]);
        array.splice(oldIndex + 1, 1);
      } else {
        array.splice(newIndex + 1, 0, array[oldIndex]);
        array.splice(oldIndex, 1);
      }
    },
    handleDroppedOutside(data, event) {
      //console.log(`You dropped with data: ${JSON.stringify(data)}`);
      this.dragging = false;
    },
    handleDrop(data, event) {
      //console.log(`You dropped with data: ${JSON.stringify(data)}`);
      console.log({ data: data });
      this.dragging = false;

      switch (this.tipo_seleccionado) {
        case "tache":
          this.seleccionado_tache = data;
          if (this.seleccionado_tache === this.seleccionado_check)
            this.seleccionado_check = null;
          console.log({
            seleccion: this.tipo_seleccionado + " " + this.seleccionado_tache,
          });
          break;
        case "check":
          this.seleccionado_check = data;
          if (this.seleccionado_tache === this.seleccionado_check)
            this.seleccionado_tache = null;
          console.log({
            seleccion: this.tipo_seleccionado + " " + this.seleccionado_check,
          });
          break;
      }

      this.tipo_seleccionado = null;
    },
    dragEnterSelect(data, event) {
      console.log(`You took data: ${JSON.stringify(data)}`);
      this.dragging = true;
      this.tipo_seleccionado = data;
    },
    avanzar() {
      if (this.tipo_reto === "multiple") {
        if (this.res === -1) {
          swal.fire(
            "Oops",
            "Selecciona una opción antes de continuar...",
            "warning"
          );
          return;
        }
      } else if (this.tipo_reto === "seleccion") {
        if (this.seleccionado_check == null) {
          swal.fire(
            "Oops",
            "Arrastra una paloma a alguna de las opciones ...",
            "warning"
          );
          return;
        } else if (this.seleccionado_tache == null) {
          swal.fire(
            "Oops",
            "Arrastra una equis a alguna de las opciones ...",
            "warning"
          );
          return;
        }
      }

      this.setAvance();
      //this.resultado = true;
    },
    retroceder() {
      this.$router.push("/mision-2-template/" + this.reto);
    },
    async setAvance() {
      let thes = this;
      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
        },
      };

      if (this.tipo_reto == "multiple") {
        data.write.respuestas[this.reto].respuestas = {
          tipo: "fortaleza",
          res: {
            fortaleza: this.retos[this.reto].respuestas[this.res],
            debilidad: null,
          },
        };
        // console.log(this.reto)
        // console.log({datawrite: data.write})
      } else if (this.tipo_reto == "seleccion") {
        let obj = {
          fortaleza: this.retos[this.reto].respuestas[this.seleccionado_check],
          debilidad: this.retos[this.reto].respuestas[this.seleccionado_tache],
        };
        data.write.respuestas[this.reto].respuestas = {
          tipo: "fortaleza",
          res: obj,
        };
      }

      await this.$store.dispatch("setAvance", data);

      if (this.reto + 2 <= this.retos.length) {
        console.log({ reto: this.reto });
        console.log("navegando a: " + "/mision-2-template/" + (this.reto + 2));
        this.$router.push("/mision-2-template/" + (this.reto + 2));
      } else {
        swal
          .fire({
            title: "¿Estás seguro(a) de enviar tus respuestas?",
            icon: "info",
            html:
              "Recuerda que no hay vuelta atrás, no podrás cambiar tus respuestas para este nivel más adelante. Selecciona 'No estoy seguro' para cambiar tus respuestas.",
            showCancelButton: true,
            confirmButtonText: `Sí, continuar`,
            cancelButtonText: `No estoy seguro`,
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              thes.confirmarRespuestas();
            }
          });
      }
    },
    async confirmarRespuestas() {
      this.evaluar();

      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
          habilidades: this.suma,
        },
      };

      await this.$store.dispatch("setAvance", data);
      await this.$store.dispatch("registroMision2", data);
      //this.resultado = true;

      this.$router.push("/mision-2-resultados");
    },
    evaluar() {
      let thes = this;

      this.suma = {
        habilidad_0: 0,
        habilidad_1: 0,
        habilidad_2: 0,
        habilidad_3: 0,
      };
      this.fortaleza = {
        habilidad_0: 0,
        habilidad_1: 0,
        habilidad_2: 0,
        habilidad_3: 0,
      };

      this.respuestas_usuario.forEach((element) => {
        //console.log(element.tipo);
        if (element.tipo == "orden") {
          for (var i = 0; i < element.respuestas.length; i++) {
            let valor = 4 - i;
            console.log({ tipo: element.tipo });
            thes.suma["habilidad_" + element.respuestas[i].habilidad] += valor;
          }
        } else {
          console.log({ sumando_fortaleza: element.respuestas.res.fortaleza });
          thes.fortaleza[
            "habilidad_" + element.respuestas.res.fortaleza.habilidad
          ] += 1;
        }
      });

      console.log({ sumas: this.suma });
      console.log({ fortaleza: this.fortaleza });

      //CALCULO DE FORTALEZA
      let fortalezas_sorted = Object.entries(this.fortaleza).sort(
        (a, b) => b[1] - a[1]
      );
      console.log({ fortalezas_sorted });
      console.log({ fortaleza_ganadora: fortalezas_sorted[0][0] });

      //añadir 5 puntos a la competencia

      this.suma[fortalezas_sorted[0][0]] += FORTALEZA_EXTRA_PUNTOS;
      //sumas_sorted = Object.entries(sumas_sorted).sort((a, b) => b[1] - a[1]);

      //CALCULO DE COMPETENCIAS

      let sumas_sorted = Object.entries(this.suma).sort((a, b) => b[1] - a[1]);
      console.log({ sumas_sorted });
      console.log({ competencia_ganadora: sumas_sorted[0][0] });

      console.log({ sumas_sorted_confortaleza: sumas_sorted });
      console.log({ competencia_ganadora: sumas_sorted[0][0] });

      //asigna perfil de competencias:
      let competencias = [];
      sumas_sorted.forEach((element) => {
        if (element[1] >= PUNTAJE_MINIMO_COMPETENCIA) {
          competencias.push(element);
        }
      });
      console.log({ competencias: competencias });
      this.resultado_evaluacion.competencias = competencias;

      //asigna fortaleza
      this.resultado_evaluacion.fortaleza = fortalezas_sorted[0][0];

      // console.log({ resultado_evaluacion: this.resultado_evaluacion });
    },
    initTimer() {
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    tick() {
      if (this.resultado === true) return;

      this.time++;
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    siguienteMision() {
      this.$router.push("/mision-1-2");
    },
    toggleOraculo() {
      this.oraculo = !this.oraculo;
    },
  },
};
</script>


<style lang="scss" scoped>
$electrico: #36d8f3;
.mision {
  .contentabs {
    .oraculo {
      top: 0%;
      width: 34vw;
      right: 0vw;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      .btnoraculo {
        width: 80%;
        margin-left: 20%;
        position: relative;
      }
      .dialogo {
        position: absolute;
        right: 0%;
        top: 0%;
        width: 120%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
          pointer-events: initial;
        }
        .cerrar {
          position: absolute;
          top: 3%;
          right: 6%;
        }
        .titulo {
          position: absolute;
          width: 50%;
          margin: 0 10% 0 40%;
          top: 12%;
          height: 20%;
          display: flex;
          align-items: center;
          font-size: 1.5vw;
        }
        .texto {
          position: absolute;
          width: 80%;
          margin: 0 10%;
          top: 40%;
          font-size: 1.4vw;
        }
      }
    }
    .tiempo-score {
      position: absolute;
      bottom: 3vw;
      right: 8vw;
      width: 20vw;
    }
    .btnavanzar {
      color: white;
      top: 14.5%;
      right: 0%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 35%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 0.9vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .btnretroceder {
      color: white;
      top: 14.5%;
      left: -5%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 45%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 0.9vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .menu {
      bottom: 0%;
      left: 0%;
      right: 0%;
      width: 100%;
      position: absolute;
      .medidor {
        width: 88%;
        margin: 0 6%;
      }
      .contenedoropciones {
        position: absolute;
        bottom: 0%;
        width: 100%;
        display: flex;
        .opcionessortable {
          position: relative;
          padding-bottom: 10%;
          width: 24%;
          margin: 0 0.4%;
          float: left;
          .opcion {
            position: relative;
            .texto {
              position: absolute;
              top: 46%;
              transform: translateY(-50%);
              color: white;
              position: absolute;
              font-size: 0.9vw;
              width: 60%;
              margin: 0 20%;
              font-weight: bold;
              text-align: center;
            }
            img {
              width: 100%;
            }
          }
        }
        .opcionessortable > *.dragging {
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
        }
      }
      &.multiple {
        left: -5%;
        width: 110%;
        .contenedoropciones {
          position: absolute;

          width: 90%;
          margin: 0 5%;
          bottom: 55%;
          .opcionesmultiple {
            position: relative;
            top: 0%;
            width: 24%;
            margin: 0 0.4%;
            float: left;
            .opcion {
              position: relative;
              .texto {
                position: absolute;
                top: 46%;
                transform: translateY(-50%);
                color: white;
                position: absolute;
                font-size: 1.1vw;
                width: 60%;
                margin: 0 20%;
                font-weight: bold;
                text-align: center;
              }
              img {
                width: 100%;
              }
            }
          }
        }
        .checks {
        }
        .check1 {
        }
        .check2 {
        }
        .check3 {
        }
        .check4 {
        }
      }
      &.seleccion {
        position: absolute;
        width: 100%;
        margin: 0 0%;
        bottom: 0%;
        z-index: 1;

        .contmedidor {
          position: relative;
          z-index: 10;
          .medidor {
            position: relative;
            width: 16%;
            margin: 0 40%;
            height: 5vw;

            .check {
              position: absolute;
              top: 0%;
              left: 4%;
              width: 9vw;

              img {
                width: 60%;
                margin: 0 20%;
                height: 80%;
                margin-top: 0%;
              }
            }
            .tache {
              position: absolute;
              top: 0%;
              right: 0%;
              width: 9vw;

              img {
                width: 60%;
                margin: 0 20%;
                height: 80%;
                margin-top: 0%;
              }
            }
          }
        }

        .contenedoropciones {
          height: 10vh;
          z-index: 1;
        }
        .opcionesseleccion {
          position: relative;
          bottom: 200%;
          width: 100%;
          margin: 0 0.4%;
          float: left;
          display: flex;
          justify-content: center;
          .opcion {
            position: relative;
            .texto {
              position: absolute;
              top: 46%;
              transform: translateY(-50%);
              color: white;
              position: absolute;
              font-size: 1.1vw;
              width: 60%;
              margin: 0 20%;
              font-weight: bold;
              text-align: center;
            }
            img {
              height: 100%;
            }
            .checkbox {
              width: 5vw;
              height: 5vw;
              left: 0%;
              text-align: center;
              .check {
                position: absolute;
                top: 12%;
                left: 0%;
                width: 100%;
                pointer-events: none;
                height: 6vh;
              }
              .tache {
                position: absolute;
                top: 12%;
                left: 0%;
                width: 100%;
                pointer-events: none;
                height: 6vh;
              }
            }
          }
        }
      }
      &.dragging {
        .tache,
        .check {
          pointer-events: none;
        }
      }
    }
    .pregunta {
      top: 0%;
      left: 8%;
      width: 72%;
      position: absolute;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
      }
    }
    .quasar {
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .mensaje {
      position: absolute;
      top: -12vw;
      left: 50%;
      width: 22vw;
      z-index: -1;
      img {
        width: 100%;
      }
      .texto {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 0.3vw 1vw 0.3vw 2vw;
        display: flex;
        justify-content: center;
        align-items: center;
        div,
        span {
          font-size: 1.4vw;
        }
      }
      &.invertido {
        left: -15vw;
        .texto {
          padding: 0.3vw 1vw 0.3vw 2vw;
        }
      }
    }
    .checkbox {
      top: 94%;
      width: 20%;
      position: absolute;
      left: 40%;
      cursor: pointer;
      .check,
      .tache {
        position: absolute;
        top: 0%;
        left: 10%;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
        }
      }
    }
  }
}

.bg1 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-1.jpg);
}
.bg2 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-2.jpg);
}
.bg3 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-3.jpg);
}
.bg4 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-4.jpg);
}
.bg5 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-5.jpg);
}
.bg6 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-6.jpg);
}
.bg7 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-7.jpg);
}
.bg8 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-8.jpg);
}
.bg9 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-9.jpg);
}
.bg10 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-10.jpg);
}
.bg11 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-11.jpg);
}
.bg12 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-12.jpg);
}
.bg13 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-13.jpg);
}
.bg14 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-14.jpg);
}
.bg15 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-15.jpg);
}
.bg16 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-16.jpg);
}
.bg17 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-17.jpg);
}
.bg18 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-18.jpg);
}
.bg19 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-19.jpg);
}
.bg20 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-20.jpg);
}
.bg21 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-21.jpg);
}
.bg22 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-22.jpg);
}
.bg23 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-23.jpg);
}
.bg24 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-24.jpg);
}
.bg25 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-25.jpg);
}
.bg26 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-26.jpg);
}
.bg27 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-27.jpg);
}
.bg28 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-28.jpg);
}
.bg29 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-29.jpg);
}
.bg30 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-30.jpg);
}
.bg31 {
  background-image: url(../../../assets/imgs/mision/2/bg-mision-2-31.jpg);
}

.mision1_1 {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  .alien {
    bottom: 0%;
    left: 12%;
    width: 13%;
    position: absolute;
    .atomo {
      position: absolute;
      top: 0%;
      left: -40%;
      width: 150%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .smartphone {
    top: -90%;
    left: 34%;
    width: 8%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -65%;
      width: 240%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .libro {
    top: -80%;
    left: 55%;
    width: 12%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -65%;
      left: -40%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .guantes {
    top: -105%;
    left: 78%;
    width: 12%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -45%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
}

.drag {
  cursor: pointer;
}

.glowing {
  animation: glowing 1s infinite !important;
}

.glow {
  box-shadow: 0 0 20px $electrico;
}
</style>
